import React, { useState } from "react";
import { Input, Button, Table, Spin } from "antd";

const { TextArea } = Input;

const CheckMVD = () => {
  const [trackingList, setTrackingList] = useState("");
  const [trackingResults, setTrackingResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleTrackingListSubmit = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        "https://us-central1-get-feedback-a0119.cloudfunctions.net/app/api/shopee/trackingList",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            trackingList: trackingList.split("\n").map((line) => {
              const [trackingID, cellphone] = line
                .split("|")
                .map((item) => item.trim());
              return { trackingID, cellphone };
            }),
          }),
        }
      );
      const data = await response.json();
      setTrackingResults(data.trackingResults);
    } catch (error) {
      console.error("Error fetching tracking results:", error);
    } finally {
      setLoading(false);
    }
  };

  // Define columns for the table
  const columns = [
    {
      title: "Tracking ID",
      dataIndex: "trackingID",
      key: "trackingID",
    },
    {
      title: "Time",
      dataIndex: ["result", "time"],
      key: "time",
    },
    {
      title: "Date",
      dataIndex: ["result", "date"],
      key: "date",
    },
    {
      title: "Message",
      dataIndex: ["result", "message"],
      key: "message",
    },
    {
      title: "Tracking",
      key: "tracking",
      render: (_, record) => {
        let link = "";
        const { trackingID, cellphone } = record;

        if (trackingID.startsWith("SPX") || trackingID.startsWith("VN")) {
          link = `https://spx.vn/m/tracking-detail/${trackingID}`;
        } else if (trackingID.startsWith("G")) {
          link = `https://donhang.ghn.vn/?order_code=${trackingID}`;
        } else if (
          trackingID.startsWith("NJV") ||
          trackingID.startsWith("SPE")
        ) {
          link = `https://www.ninjavan.co/vi-vn/tracking?id=${trackingID}`;
        }

        if (cellphone) {
          link = `https://jtexpress.vn/vi/tracking?type=track&billcode=${trackingID}&cellphone=${cellphone}`;
        }

        return (
          <Button type="link" href={link} target="_blank">
            Open Link
          </Button>
        );
      },
    },
  ];

  return (
    <div className="w-screen h-screen flex flex-col justify-between items-center">
      {/* Header */}
      <header className="py-4 text-white text-2xl bg-gray-800 w-full text-center">
        Tracking MVD
      </header>
      <div className="flex flex-col items-center">
        {/* Text area for input */}
        <TextArea
          placeholder="Enter trackingID | cellphone..."
          autoSize={{ minRows: 4, maxRows: 8 }}
          value={trackingList}
          onChange={(e) => setTrackingList(e.target.value)}
        />
        {/* Submit button */}
        <Button
          type="primary"
          className="mt-4"
          onClick={handleTrackingListSubmit}
        >
          Submit
        </Button>
        <div className="mt-4">
          {/* Show loading spin while waiting for response */}
          <Spin spinning={loading}>
            {/* Table to display tracking results */}
            <Table
              dataSource={trackingResults}
              columns={columns}
              pagination={{ pageSize: 10 }}
            />
          </Spin>
        </div>
      </div>
      {/* Footer */}
      <footer className="py-4 text-white bg-gray-800 w-full text-center">
        © 2024 AutoPee. All rights reserved.
      </footer>
    </div>
  );
};

export default CheckMVD;
